<template>
  <div>
    <div @click="openModal()">
      <div class="cursor-pointer"><vk-icon icon="move" /><span></span></div>
    </div>
  </div>
</template>

<script>
import EventBus from "../EventBus";
export default {
  name: "id",
  data() {
    return {
      link: "edit/" + this.input.table,
      model: null,
      show: false
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
    if (this.input.options) {
      this.link = this.input.options;
    }
  },

  methods: {
    openModal() {
      EventBus.$emit("editModalShow", {
        table: this.input.table,
        id: this.model
      });
    }
  }
};
</script>
